import React, { useState } from "react";

import { Activity as ActivityType } from "@packages/client";

import { entities } from "Libs/platform";
import LogModal from "src/organization/common/components/ActivityList/LogModal/LogModal";

import { default as Alert } from "./Alert";
import { default as Deployment } from "./Deployment";
import { ActivityLineType, ActivityPropType } from "./type";

const list = {
  deployment: Deployment,
  autoscale: Alert
} as const;

const Activity = (props: ActivityPropType & { type: ActivityLineType }) => {
  const Comp = list[props.type];
  const [activity, setActivity] = useState<ActivityType | null>(null);

  return Comp ? (
    <>
      <Comp
        {...props}
        onClick={activity => {
          setActivity(activity);
        }}
      />
      {activity && (
        <LogModal
          initialActivity={
            new entities.Activity(activity, activity._links?.self.href || "")
          }
          closeModal={() => {
            setActivity(null);
          }}
        />
      )}
    </>
  ) : null;
};

export default React.memo(Activity);
